module.exports = __webpack_public_path__ + "img/failed-status.649cbe4c.svg";